(() => {
  const el = document.getElementById('SitePreloader');
  if (!el) return;

  // Dev helper: /?preloader=1&delay=6000
  const params = new URLSearchParams(window.location.search);
  const force = params.get('preloader') === '1';
  const forcedDelay = parseInt(params.get('delay') || '0', 10);

  const once = el.dataset.oncePerSession === 'true';
  const minMs = parseInt(el.dataset.minMs || '0', 10);
  const intervalMs = parseInt(el.dataset.intervalMs || '650', 10);

  let words = [];
  try { words = JSON.parse(el.dataset.words || '[]'); } catch(e) { words = []; }
  if (!Array.isArray(words) || words.length === 0) words = ['Loading'];

  if (!force && once) {
    try {
      if (sessionStorage.getItem('sp_seen') === '1') {
        el.classList.add('is-hiding');
        return;
      }
    } catch(e){}
  }

  const wheel = el.querySelector('[data-sp-wheel]');
  if (!wheel) return;

  // Build items
  wheel.innerHTML = '';
  const items = words.map((t, i) => {
    const d = document.createElement('div');
    d.className = 'sp__item';
    d.style.setProperty('--i', i);
    d.textContent = t;
    wheel.appendChild(d);
    return d;
  });

  // Cylinder geometry:
  // step = 360 / n; radius approx based on item height so it looks “round”
  const n = items.length;
  const step = 360 / n;

  // After first paint, measure height and compute radius
  const compute = () => {
    const h = wheel.getBoundingClientRect().height || 40;
    // radius formula for a nice cylinder: r = (h/2) / tan(pi/n)
    const r = (h * 0.55) / Math.tan(Math.PI / n);
    wheel.style.setProperty('--sp-step', `${step}deg`);
    wheel.style.setProperty('--sp-radius', `${Math.max(24, Math.min(140, r))}px`);
  };

  // ensure layout is ready
  requestAnimationFrame(() => {
    compute();
    items[0].classList.add('is-active');
  });

  // Rotate
  let idx = 0;
  let rot = 0;

  const setActive = (newIdx) => {
    items.forEach((it, i) => it.classList.toggle('is-active', i === newIdx));
  };

  const tick = () => {
    idx = (idx + 1) % n;
    rot -= step; // rotate wheel upward
    wheel.style.setProperty('--sp-rot', `${rot}deg`);
    setActive(idx);
  };

  const rotTimer = setInterval(tick, intervalMs);

  // Recompute on resize (keeps cylinder correct across breakpoints)
  let rTO = null;
  window.addEventListener('resize', () => {
    clearTimeout(rTO);
    rTO = setTimeout(compute, 120);
  });

  // Hide logic
  const startTs = Date.now();

  const hide = () => {
    const elapsed = Date.now() - startTs;
    const required = Math.max(minMs, forcedDelay);
    const wait = Math.max(0, required - elapsed);

    setTimeout(() => {
      clearInterval(rotTimer);
      el.classList.add('is-hiding');

      if (!force && once) {
        try { sessionStorage.setItem('sp_seen', '1'); } catch(e){}
      }

      setTimeout(() => el.remove(), 600);
    }, wait);
  };

  window.addEventListener('load', hide, { once: true });

  // safety fallback
  setTimeout(hide, Math.max(4000, Math.max(minMs, forcedDelay) + 1500));
})();
